export const Constants = {
  address: 'logradouro:',
  addressNumber: 'número:',
  addressComplement: 'complemento:',
  addressCep: 'CEP:',
  addressDistrict: 'bairro:',
  addressCity: 'cidade:',
  addressUF: 'estado:',
  searchMap: 'pesquisar no mapa',
  lat: 'Latitude: ',
  lng: 'Longitude:',
  standard: 'padrão',
  satellite: 'satélite',
  noImage: 'esta os não possui mapa',
};
